import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { PaginationConfigService } from '../../../services/paginationconfig.service';

@Component({
  selector: 'app-global-paginator',
  templateUrl: './global-paginator.component.html',
  styleUrls: ['./global-paginator.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GlobalPaginatorComponent implements OnInit {
  @Input() pageSize: number;
  @Input() pageIndex: number;
  @Input() length: number;
  @Input() pageSizeOptions: number[];
  @Output() globalPageChange = new EventEmitter<PageEvent>();

  constructor(private paginationConfigService: PaginationConfigService) {
    paginationConfigService?.pageSizeOptions$.subscribe((res) => {
      this.pageSizeOptions = res;
    });

    this.paginationConfigService.pageSize$.subscribe((newSize: number) => {
      this.pageSize = newSize;
    });
    this.paginationConfigService.pageIndex$.subscribe(
      (newIndex: number) => {
        this.pageIndex = newIndex;
      }
    );
  }

  ngOnInit(): void {
    // const initialPageEvent: PageEvent = {
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize,
    //     length: this.length,
    // };
    // this.onPageChange(initialPageEvent);
  }

  onPageChange(event: PageEvent) {
    this.paginationConfigService.handlePageEvent(event);
    this.globalPageChange.emit(event);
  }
}
